<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH1')" />
            <Button label="입력" icon="pi pi-pencil" class="p-button-success mr-2" @click="btnAct('NEW1')" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="compSeq" v-model="searchParams.compSeq" :options ="compCodes" optionLabel="codeNm" optionValue="code" required="true" :showClear="true" style="width: 11rem"/>
                        <label for="compSeq">센터명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="helpNm" type="text" v-model="searchParams.helpNm" @keydown.enter="btnAct('SEARCH1')"/>
                        <label for="helpNm">코드도움명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="helpId" type="text" v-model="searchParams.helpId" @keydown.enter="btnAct('SEARCH1')"/>
                        <label for="helpId">코드도움ID</label>
                    </div>
                </div> 
            </template>
            <template #end>
            </template>
        </Toolbar>
        
        <Splitter style="height: 78vh">
            <SplitterPanel  :size="35">
                <DataTable id="dt1" ref="dt1" :value="codeHelps" dataKey="helpSeq" style="width: 35vw"
                    selectionMode="single" v-model:selection="selectedCodeHelp" showGridlines="true"
                    editMode="row" v-model:editingRows="editingRows1" rowIndexVar="rowIndex" removableSort 
                    :scrollable="true" scrollHeight="82vh" scrollDirection="both"
                    @rowEditInit="onRowEditInit1"  @rowEditCancel="onRowEditCancel1" @rowEditSave="onRowEditSave1"
                    class="p-datatable-sm"  responsiveLayout="scroll">
                    <template #empty>
                        No records found
                    </template>
                    <template #loading>
                        Loading ... Please wait.
                    </template>
                    <Column header="No" class="t-center" style="min-width:2em; max-width:2em; z-index: 9" frozen>
                        <template #body="{index}">
                            {{ index + 1 }}
                        </template>    
                    </Column>
                    <Column field="helpId" header="코드도움ID" style="min-width:10em; max-width:10em; z-index: 9" :sortable="true" frozen>
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="10" style="width:9em" />
                        </template>
                    </Column>
                    <Column field="helpNm" header="코드도움명"  style="min-width:10em; max-width:10em; z-index: 9" :sortable="true" frozen>
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="10" style="width:9em"/>
                        </template>
                    </Column>
                    <Column field="queryId" header="쿼리ID"  style="min-width:7em; max-width:7em;">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="5" style="width:6em"/>
                        </template>
                    </Column>
                    <Column field="useYn" header="사용여부"  style="min-width:5em; max-width:5em;" class="t-center">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" disabled />
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox name="useYn" :value="data.useYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="remark" header="비고"  style="min-width:10em; max-width:10em;">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="20" style="width:9em"/>
                        </template>
                    </Column>
                    <Column field="width" header="화면폭"  style="min-width:5em; max-width:5em;">
                        <template #editor="{ data, field }">
                            <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0"  inputStyle="width:4em"/>
                        </template>
                    </Column>
                    <Column field="width" header="화면높이" style="min-width:5em; max-width:5em;">
                        <template #editor="{ data, field }">
                            <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" inputStyle="width:4em"/>
                        </template>
                    </Column>
                    <Column :rowEditor="true"  style="min-width:5em; max-width:5em;" bodyStyle="text-align:center"></Column>
                    <Column :exportable="false" frozen>
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="rowBtnAct('DELETE1',slotProps.data)" />
                        </template>
                    </Column>
                </DataTable>
            </SplitterPanel>    

            <SplitterPanel :size="65">
                <Splitter style="height: 75vh" class="mb-5" layout="vertical">
                    <SplitterPanel  :size="40">
                        <div class="card">
                            <div class="p-grid p-mt-1">
                                <div class="p-fluid p-col-2">
                                    <span class ="p-float-label">
                                        <InputText type="text" v-model.trim="selectedCodeHelp.helpId" disabled />
                                        <label>코드도움ID</label>
                                    </span>
                                </div>
                                <div class="p-fluid p-col-2">
                                    <span class ="p-float-label">
                                        <InputText type="text" v-model.trim="selectedCodeHelp.helpNm" disabled />
                                        <label>코드도움명</label>
                                    </span>
                                </div>
                                <div class="p-fluid p-col-2">
                                    <span class ="p-float-label">
                                        <InputText type="text" v-model.trim="selectedCodeHelp.queryId" disabled />
                                        <label>쿼리ID</label>
                                    </span>
                                </div>
                                <div class="p-fluid p-col-6">
                                    <span class ="p-float-label">
                                        <InputText type="text" v-model.trim="selectedCodeHelp.remark" disabled />
                                        <label>비고</label>
                                    </span>
                                </div>
                            </div>
                        </div>
 
                        <DataTable id="dt2" ref="dt2" :value="codeHelpConds" dataKey="condSerl" showGridlines style="width: 62vw"
                            selectionMode="multiple" v-model:selection="selectedCodeHelpConds" :scrollable="false" scrollHeight="300px"
                            editMode="row" v-model:editingRows="editingRows2" 
                            @rowEditInit="onRowEditInit2"  @rowEditCancel="onRowEditCancel2" @rowEditSave="onRowEditSave2"
                            class="p-datatable-sm"  responsiveLayout="scroll">
                            <template #header>
                                <div class="flex justify-content-between flex-wrap">
                                    <div class="flex align-items-center justify-content-center">
                                        <i class="pi pi-tag mr-2"></i>
                                        <span>조회조건</span>
                                    </div>
                                    <div class="flex align-items-center justify-content-center">
                                        <Button label="추가" icon="pi pi-plus" class="p-button-secondary mr-2" @click="btnAct('NEW2')" />
                                    </div>
                                </div>
                            </template>
                            <Column header="No" style="min-width:3em; max-width:3em">
                                <template #body="{index}">
                                    {{ index + 1 }}
                                </template>    
                            </Column>
                            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false"></Column>
                            <Column field="condId" header="조회조건ID" :sortable="true">
                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" maxLength="20" style="min-width:8em; max-width:8em"/>
                                </template>
                            </Column>
                            <Column field="condNm" header="조회조건명" :sortable="true">
                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" maxLength="20" style="min-width:8em; max-width:8em"/>
                                </template>
                            </Column>
                            <Column field="inputType" header="입력유형">
                                <template #editor="{ data, field }">
                                    <Dropdown v-model="data[field]" :options="inputTypes" optionLabel="codeNm" optionValue="code" />
                                </template>
                            </Column>
                            <Column field="constant" header="쿼리상수">
                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" maxLength="20" style="width:5em"/>
                                </template>
                            </Column>
                            <Column field="emptyYn" header="전체여부" style="min-width:5em; max-width:5em;">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" disabled />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox name="emptyYn" :value="data[field]" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="disableYn" header="비활성화" style="min-width:5em; max-width:5em;">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" disabled />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox name="disableYn" :value="data[field]" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="useYn" header="사용여부" class="t-center" style="min-width:5em; max-width:5em;"> 
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" disabled />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :value="data[field]" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="remark" header="비고">
                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" maxLength="100" style="width:5em;"/>
                                </template>
                            </Column>
                            <Column :rowEditor="true" style="min-width:6rem; max-width:6rem" bodyStyle="text-align:center"></Column>
                            <Column :exportable="false" style="min-width:3em; max-width:3em">
                                <template #body="slotProps">
                                    <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="rowBtnAct('DELETE2',slotProps.data)" />
                                </template>
                            </Column>
                        </DataTable>
                    </SplitterPanel>

                    <SplitterPanel  :size="60">
                        <DataTable id="dt2" ref="dt2" :value="codeHelpCols" dataKey="colSerl" showGridlines style="width: 62vw"
                            selectionMode="multiple" v-model:selection="selectedCodeHelpCols" :scrollable="false" scrollHeight="800px"
                            editMode="row" v-model:editingRows="editingRows3" sortMode="multiple"
                            @rowEditInit="onRowEditInit3"  @rowEditCancel="onRowEditCancel3" @rowEditSave="onRowEditSave3"
                            class="p-datatable-sm table-con"  responsiveLayout="scroll">
                            <template #header>
                                <div class="flex justify-content-between flex-wrap">
                                    <div class="flex align-items-center justify-content-center">
                                        <i class="pi pi-tag mr-2"></i>
                                        <span>컬럼</span>
                                    </div>
                                    <div class="flex align-items-center justify-content-center">
                                        <Button label="추가" icon="pi pi-plus" class="p-button-secondary mr-2" @click="btnAct('NEW3')" />
                                    </div>
                                </div>
                            </template>
                            <Column header="No" style="min-width:3em; max-width:3em">
                                <template #body="{index}">
                                    {{ index + 1 }}
                                </template>    
                            </Column>
                            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false"></Column>
                            <Column field="colId" header="컬럼ID" :sortable="true">
                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" maxLength="20" style="min-width:8em; max-width:8em"/>
                                </template>
                            </Column>
                            <Column field="colNm" header="컬럼명" :sortable="true">
                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" maxLength="20" style="min-width:8em; max-width:8em"/>
                                </template>
                            </Column>
                            <Column field="inputType" header="입력유형" :sortable="true">
                                <template #editor="{ data, field }">
                                    <Dropdown v-model="data[field]" :options="inputTypes2" optionLabel="codeNm" optionValue="code" />
                                </template>
                            </Column>
                            <Column field="width" header="컬럼너비" :sortable="true">
                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" maxLength="20" style="min-width:8em; max-width:8em"/>
                                </template>
                            </Column>
                            <Column field="constant" header="상수값" :sortable="true">
                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" maxLength="20" style="min-width:8em; max-width:8em"/>
                                </template>
                            </Column>
                            <Column field="align" header="정렬" :sortable="true">
                                <template #editor="{ data, field }">
                                    <Dropdown v-model="data[field]" :options="aligns" optionLabel="codeNm" optionValue="code" />
                                </template>
                            </Column>
                            <Column field="hiddenYn" header="숨김여부" style="min-width:6em; max-width:6em;">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" disabled />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox name="hiddenYn" :value="data.hiddenYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="useYn" header="사용여부" class="t-center" style="min-width:6em; max-width:6em;" :sortable="true" >
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" disabled />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox name="useYn" :value="data.useYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="sortOrd" header="정렬순서" :sortable="true">
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" :min="0" integeronly showButtons="true" inputStyle="width:3em"/>
                                </template>
                            </Column>
                            <Column field="remark" header="비고" :sortable="true">
                                <template #editor="{ data, field }">
                                    <InputText v-model="data[field]" maxLength="100" style="width:10em;"/>
                                </template>
                            </Column>
                            <Column :rowEditor="true" style="min-width:5rem; max-width:5rem" bodyStyle="text-align:center"></Column>
                            <Column :exportable="false" style="min-width:4em; max-width:4em">
                                <template #body="slotProps">
                                    <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="rowBtnAct('DELETE3',slotProps.data)" />
                                </template>
                            </Column>
                        </DataTable>
                    </SplitterPanel>
                </Splitter>
            </SplitterPanel>
        </Splitter>
    </div>
</template>

<script>
import { ref, onMounted, reactive, watch } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import CodeHelpService from '@/service/cm/CodeHelpService';
import CodeHelpCondService from '@/service/cm/CodeHelpCondService';
import CodeHelpColService from '@/service/cm/CodeHelpColService';
import JsUtils from '@/utilities/JsUtils';
//import { uuid } from 'vue3-uuid';

export default {
    setup() {
        onMounted(() => {
            searchParams.compSeq = 1;
            searchCodeHelps();

            //UUID.value = uuid.v3();
            //UUID.value = uuid.v4();
        })
		const codeHelpService = new CodeHelpService();
        const codeHelpCondService = new CodeHelpCondService();
        const codeHelpColService = new CodeHelpColService();
        const searchParams = reactive({compSeq:null,helpNm:null,helpId:null});
        const toast = useToast();
        const confirm = useConfirm();
        const codeHelps = ref([]);
        const codeHelpConds = ref([]);
        const codeHelpCols = ref([]);
		const selectedCodeHelp = ref({});
		const selectedCodeHelpConds = ref([]);
        const selectedCodeHelpCols = ref([]);
        const helpIdCodes = ref([]);
        const editingRows1 = ref([]);
        const editingRows2 = ref([]);
        const editingRows3 = ref([]);
        const originalRows1 = ref({});
        const originalRows2 = ref({});
        const originalRows3 = ref({});
        //const UUID = ref(null);
        
        const compCodes = ref([
            {codeNm: '경남도청', code: 1},
        ]);
        const screenCodes = ref([
            {codeNm: '소분류', code: 1},
            {codeNm: '타이틀', code: 2}
        ]);
        const inputTypes = ref([
            {codeNm: 'text', code: 'text'},
            {codeNm: 'combo', code: 'combo'},
            {codeNm: 'date', code: 'date'}
        ]);
        const inputTypes2 = ref([
            {codeNm: 'text', code: 'text'},
            {codeNm: 'combo', code: 'combo'},
            {codeNm: 'checkbox', code: 'checkbox'},
            {codeNm: 'date', code: 'date'},
            {codeNm: 'number', code: 'number'},
            {codeNm: 'codehelp', code: 'codehelp'}
        ]);
        const aligns = ref([
            {codeNm: 'left', code: 'left'},
            {codeNm: 'center', code: 'center'},
            {codeNm: 'right', code: 'right'}
        ]);
        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH1":
                        searchCodeHelps();
                        break;
                case "SEARCH2":
                        searchCodeHelpConds();
                        break;
                case "SEARCH3":
                        searchCodeHelpCols();
                        break;
                case "NEW1":
                        addNewItem1();
                        break;
                case "NEW2":
                        addNewItem2();                  
                        break;
                case "NEW3":
                        addNewItem3();                  
                        break;
                default:
                        break;
            }
        }

        const rowBtnAct = (_act, code)=>
        {
            switch(_act)
            {
                case "DELETE1":
                    confirmDeleteOne1(code);
                    break;
                case "DELETE2":
                    confirmDeleteOne2(code);
                    break;
                case "DELETE3":
                    confirmDeleteOne3(code);
                    break;
                default:
                    break;
            }
        }
        
        /**
         * 코드도움 조회 시
         */
        const searchCodeHelps = () => {
            editingRows1.value = [];

            codeHelpService.getList(searchParams).then(data => {
                codeHelps.value = data;

                codeHelps.value.forEach(row => {
                    row.useYn = row.useYn == 1 ? true : false;
                });

                if(codeHelps.value.length > 0) {
                    // 목록에서 첫번째 건에 대한 상세 정보를 조회하여 표시한다
                    selectedCodeHelp.value = codeHelps.value[0];

                    searchCodeHelpConds();
                    searchCodeHelpCols();
                }
            });
			return;
        };

        /**
         * 코드도움 목록에 신규 행을 추가한다
         */
        const addNewItem1 = () => {
            // 이미 편집중인 row가 있으면 취소한다 - 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows1.value.length > 0) {
                return;
            }

            var newCode = {compSeq: searchParams.compSeq, useYn: true};
            if(codeHelps.value.length > 0) {
                // 기존 목록 뒤에 추가한다
                //var _ = require('lodash');
                //const lastCode = _.maxBy(codeHelps.value, 'align'); // 마지막 순번
                codeHelps.value.splice(0,0, newCode);
            }
            else {
                // 목록의 첫번째에 추가한다
                codeHelps.value.push(newCode);
                //codeHelps.value.unshift(newCode);
            }

            // 목록의 첫번째 row를 편집 상태로 변경한다
            editingRows1.value = [...editingRows1.value, codeHelps.value[0]];    
        }

        /**
         * 코드도움 행 편집 시작 시
         */
        const onRowEditInit1 = (event) =>{
            // 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows1.value.length > 1) {
                // 목록에서 마지막으로 선택한 행이 배열에서 마지막에 추가되므로 마지막으로 추가된 항목을 삭제한다
                editingRows1.value.pop();
                return;
            }

            originalRows1.value[event.index] = {...codeHelps.value[event.index]};
        }

        /**
         * 코드도움 행 편집 취소 시
         */
        const onRowEditCancel1 = (event) => {
            let {newData} = event;
            if(newData == null || newData.helpSeq == null) {  // 화면에서 신규 추가한 경우
                codeHelps.value.shift(); // 배열의 맨 앞의 항목을 제거한다.
                editingRows1.value = [];
                return;
            }

            codeHelps.value[event.index] = originalRows1.value[event.index];
        }  

        /**
         * 코드도움 행 저장 시
         */
        const onRowEditSave1 = (event) =>{
            let {newData, index} = event;

            if(!JsUtils.checkUndefineColumns(newData,["compSeq","helpId","helpNm"])){
                // 현재 수정중인 row를 편집 상태로 변경한다
                editingRows1.value = [...editingRows1.value, newData];    
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'코드도움ID, 코드도움명은 필수입력 항목입니다', life:2000});
                return;
            }

            newData.useYn =  newData.useYn == true ? 1 : 0;

            if(newData.helpSeq == null) {
                codeHelpService.insertOne(newData).then(() => {                    
                    toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});
                    btnAct('SEARCH1');
                });
            } else {
                codeHelpService.updateOne(newData).then(() => {
                    codeHelps.value[index] = newData;
                    toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                });
            }
        }

        /**
         * 코드도움 행 삭제 시
         */
        const confirmDeleteOne1 = (code) =>{
            confirm.require({
                message:`대분류(${code.helpNm})를 삭제하시겠습니까?`,
                header: '대분류 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteOne1(code);
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteOne1 = (code) => {
            codeHelpService.deleteOne(code.compSeq, code.helpSeq)
                .then(() => {                    
                    toast.add({severity:'success', summary: '성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH1');
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };

        /**
         * 조회조건 조회 시
         */
        const searchCodeHelpConds = () => {
            codeHelpConds.value = [];
            selectedCodeHelpConds.value = [];
            
            codeHelpCondService.getList({compSeq: selectedCodeHelp.value.compSeq, helpSeq:selectedCodeHelp.value.helpSeq}).then(data=> {
                codeHelpConds.value = data;

                codeHelpConds.value.forEach(row => {
                    row.emptyYn = row.emptyYn == 1 ? true : false;
                    row.disableYn = row.disableYn == 1 ? true : false;
                    row.useYn = row.useYn == 1 ? true : false;
                });
            });
        }

        /**
         * 조회조건 목록에 신규 행을 추가한다
         */
        const addNewItem2 = () => {
            if(selectedCodeHelp.value == null || selectedCodeHelp.value.helpSeq == null) {
                toast.add({serverity:'warn', summary: '확인', detail: '코드도움 목록에서 코드를 선택하세요', life: 3000});
                return;
            }

            // 이미 편집중인 row가 있으면 취소한다 - 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows2.value.length > 0) {
                return;
            }

            var newCode = {compSeq: selectedCodeHelp.value.compSeq, helpSeq: selectedCodeHelp.value.helpSeq, useYn: true};

            if(codeHelpConds.value.length > 0) {
                // 기존 목록 뒤에 추가한다
                //var _ = require('lodash');
                //const lastCode = _.maxBy(codeHelpConds.value, 'align'); // 마지막 순번
                codeHelpConds.value.splice(0,0, newCode);
            }
            else {
                // 목록의 첫번째에 추가한다
                codeHelpConds.value.push(newCode);
                //codeHelpConds.value.unshift(newCode);
            }

            // 목록의 첫번째 row를 편집 상태로 변경한다
            editingRows2.value = [...editingRows2.value, codeHelpConds.value[0]];    
        }
        
        /**
         * 조회조건 행 편집 시작 시
         */
        const onRowEditInit2 = (event) =>{
            // 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows2.value.length > 1) {
                // 목록에서 마지막으로 선택한 행이 배열에서 마지막에 추가되므로 마지막으로 추가된 항목을 삭제한다
                editingRows2.value.pop();
                return;
            }

            originalRows2.value[event.index] = {...codeHelpConds.value[event.index]};
        }

        /**
         * 조회조건 행 편집 취소 시
         */         
        const onRowEditCancel2 = (event) => {
            let {newData} = event;
            if(newData == null || newData.minorSeq == null) {  // 화면에서 신규 추가한 경우
                codeHelpConds.value.shift(); // 배열의 맨 앞의 항목을 제거한다.
                editingRows2.value = [];
                return;
            }

            codeHelpConds.value[event.index] = originalRows2.value[event.index];
        }   

        /**
         * 조회조건 행 저장 시
         */
        const onRowEditSave2 = (event) =>{
            let {newData} = event;

            if(!JsUtils.checkUndefineColumns(newData,["compSeq","condId","condNm"])){
                // 현재 수정중인 row를 편집 상태로 변경한다
                editingRows2.value = [...editingRows2.value, newData];    
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'조회조건ID, 조회조건명은 필수입력 항목입니다', life:3000});
                return;
            }

            newData.emptyYn =  newData.emptyYn == true ? 1 : 0;
            newData.disableYn =  newData.disableYn == true ? 1 : 0;
            newData.useYn =  newData.useYn == true ? 1 : 0;

            if(newData.condSerl == null) {
                codeHelpCondService.insertOne(newData).then(() => {                    
                    btnAct('SEARCH2');
                    toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});
                });
            } else {
                codeHelpCondService.updateOne(newData).then(() => {
                    //codeHelpConds.value[index] = newData;
                    btnAct('SEARCH2');
                    toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                });
            }
        }

        /**
         * 조회조건 행 삭제 시
         */
        const confirmDeleteOne2 = (code) =>{
            confirm.require({
                message:`조회조건(${code.minorNm})를 삭제하시겠습니까?`,
                header: '조회조건 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteOne2(code);
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteOne2 = (code) => {
            codeHelpCondService.deleteOne(code.compSeq, code.helpSeq, code.condSerl)
                .then(() => {                    
                    toast.add({severity:'success', summary: '삭제 성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH2');
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };

        /*
        const confirmDeleteList2 = () =>{
            confirm.require({
                message:'선택된 건(들)을 삭제하시겠습니까?',
                header: '조회조건 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteList2();                    
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }
        
        const deleteList2 = () => {
            codeHelpCondService.deleteList(selectedCodeHelpConds.value)
                .then(() => {                    
                    selectedCodeHelpConds.value = [];
                    toast.add({severity:'success', summary: '삭제 성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH2');
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };
        */

        /**
         * 컬럼 조회 시
         */
        const searchCodeHelpCols = () => {
            codeHelpCols.value = [];            
            selectedCodeHelpCols.value = [];

            codeHelpColService.getList({compSeq: selectedCodeHelp.value.compSeq, helpSeq:selectedCodeHelp.value.helpSeq}).then(data=> {
                codeHelpCols.value = data;

                codeHelpCols.value.forEach(row => {
                    row.hiddenYn = row.hiddenYn == 1 ? true : false;
                    row.useYn = row.useYn == 1 ? true : false;
                });
            });
        }

        /**
         * 컬럼 목록에 신규 행을 추가한다
         */
        const addNewItem3 = () => {
            if(selectedCodeHelp.value == null || selectedCodeHelp.value.helpSeq == null) {
                toast.add({serverity:'warn', summary: '확인', detail: '코드도움 목록에서 코드를 선택하세요', life: 3000});
                return;
            }

            // 이미 편집중인 row가 있으면 취소한다 - 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows3.value.length > 0) {
                return;
            }

            var newCode = {compSeq: selectedCodeHelp.value.compSeq, helpSeq: selectedCodeHelp.value.helpSeq, useYn: true};

            if(codeHelpCols.value.length > 0) {
                // 기존 목록 뒤에 추가한다
                var _ = require('lodash');
                const lastCode = _.maxBy(codeHelpCols.value, 'sortOrd'); // 마지막 순번
                newCode.sortOrd = lastCode.sortOrd + 1;
                codeHelpCols.value.splice(0,0, newCode);
            }
            else {
                // 목록의 첫번째에 추가한다
                newCode.sortOrd = 1;
                codeHelpCols.value.push(newCode);
                //codeHelpCols.value.unshift(newCode);
            }

            // 목록의 첫번째 row를 편집 상태로 변경한다
            editingRows3.value = [...editingRows3.value, codeHelpCols.value[0]];  
        }

        /**
         *  컬럼 행 편집 시작 시
         */
        const onRowEditInit3 = (event) =>{
            // 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows3.value.length > 1) {
                // 목록에서 마지막으로 선택한 행이 배열에서 마지막에 추가되므로 마지막으로 추가된 항목을 삭제한다
                editingRows3.value.pop();
                return;
            }

            originalRows3.value[event.index] = {...codeHelpCols.value[event.index]};
        }

        /**
         * 컬럼 행 편집 취소 시
         */         
        const onRowEditCancel3 = (event) => {
            let {newData} = event;
            if(newData == null || newData.colSerl == null) {  // 화면에서 신규 추가한 경우
                codeHelpCols.value.shift(); // 배열의 맨 앞의 항목을 제거한다.
                editingRows3.value = [];
                return;
            }

            codeHelpCols.value[event.index] = originalRows3.value[event.index];
        }   

        /**
         * 컬럼 행 저장 시
         */
        const onRowEditSave3 = (event) =>{
            let {newData} = event;

            if(!JsUtils.checkUndefineColumns(newData,["compSeq","colId","colNm"])){
                // 현재 수정중인 row를 편집 상태로 변경한다
                editingRows3.value = [...editingRows3.value, newData];    
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'컬럼ID, 컬럼명은 필수입력 항목입니다', life:3000});
                return;
            }

            newData.hiddenYn =  newData.hiddenYn == true ? 1 : 0;
            newData.useYn =  newData.useYn == true ? 1 : 0;

            if(newData.colSerl == null) {
                codeHelpColService.insertOne(newData).then(() => {                    
                    toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});
                    btnAct('SEARCH3');
                });
            } else {
                codeHelpColService.updateOne(newData).then(() => {
                    //codeHelpCols.value[index] = newData;
                    btnAct('SEARCH3');
                    toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                });
            }
        }

        /**
         * 컬럼 행 삭제 시
         */
        const confirmDeleteOne3 = (code) =>{
            confirm.require({
                message:`컬럼(${code.colNm})를 삭제하시겠습니까?`,
                header: '컬럼 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteOne3(code);
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteOne3 = (code) => {
            codeHelpColService.deleteOne(code.compSeq, code.helpSeq, code.colSerl)
                .then(() => {                    
                    toast.add({severity:'success', summary: '삭제 성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH3');
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, codeHelps.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(codeHelps.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        watch(()=>selectedCodeHelp.value,
        (meta)=>{
            codeHelpConds.value = [];
            editingRows2.value = [];
            editingRows3.value = [];

            if(meta.helpSeq)
            {
                searchCodeHelpConds();
                searchCodeHelpCols();
                //codeHelpCondService.getList({compSeq: selectedCodeHelp.value.compSeq, helpSeq:meta.helpSeq}).then(data=> codeHelpConds.value = data);
                //codeHelpColService.getList({compSeq: selectedCodeHelp.value.compSeq, helpSeq:meta.helpSeq}).then(data=> codeHelpCols.value = data);
            }
        })

        return { 
            dt, codeHelps, codeHelpConds, codeHelpCols, selectedCodeHelp, selectedCodeHelpConds, selectedCodeHelpCols, searchParams, 
            helpIdCodes, screenCodes, compCodes, inputTypes, inputTypes2, aligns,   
            editingRows1, originalRows1, onRowEditInit1, onRowEditCancel1, onRowEditSave1, addNewItem1, confirmDeleteOne1, deleteOne1,
            editingRows2, originalRows2, onRowEditInit2, onRowEditCancel2, onRowEditSave2, addNewItem2, confirmDeleteOne2, deleteOne2, 
            editingRows3, originalRows3, onRowEditInit3, onRowEditCancel3, onRowEditSave3, addNewItem3, confirmDeleteOne3, deleteOne3,
            btnAct, rowBtnAct, searchCodeHelps, searchCodeHelpConds, searchCodeHelpCols,
            downloadExcel, exportCSV, 
        }
    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.code-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .code-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
